var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProjectIcon = function SvgProjectIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#050d1e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 -134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-43 135)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.474,2.309V8.183L4.784,6.338,0,8.709V18H18V2.308L13.219,0ZM5.67,16.945H3.94V15.891H5.67Zm.694,0V15.323H3.2v1.623H1.056V9.363L4.782,7.516,8.474,9.362v7.583Zm7.681,0H12.34V15.891h1.705Zm2.9-13.976V16.945H14.8V15.323H11.638v1.623H9.529V2.969l3.692-1.8Z",
    transform: "translate(18 144)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-22 127.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-19 127.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-22 130.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-19 130.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-22 133.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-19 133.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-22 136.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-19 136.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-30 133.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-27 133.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-30 136.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.741,16.263h1.5v1.5h-1.5Z",
    transform: "translate(-27 136.738)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProjectIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ProjectIcon.b11439fc8368df5b4726de50088113bc.svg";